import { getJwt, isValidJwt } from '~/utils/jwt';

export default function ({ app, redirect }) {
  const jwt = getJwt(app);

  if (!jwt || !isValidJwt(jwt)) {
    console.warn('[Middleware] Invalid or missing JWT.');
    return redirect(app.localePath('/'));
  }

  console.log('[Middleware] JWT is valid.');
}
